import React, { useState } from "react";
import Logo from "../images/sbg_logo.webp";
import SetupIcon from "../images/setup.svg";
import ClientIcon from "../images/client.svg";
import OfficerIcon from "../images/officers.svg";
import ReportIcon from "../images/reports.svg";
import LoneIcon from "../images/lone.svg";
import { Link } from "react-router-dom";
import insurances from "../images/insurances.svg";
import licenses from "../images/licenses.svg";
import subscriptions from "../images/subscriptions.svg";
import tools from "../images/tools.svg";
import vendor from "../images/vendor.svg"

const Sidebar = ({ isSidebarOpen }) => {
  const [openMenus, setOpenMenus] = useState([]);
  const [openInnerMenus, setOpenInnerMenus] = useState([]);
  const url = window.location.href;

  const handleToggle = (menuName) => {
    setOpenMenus((prev) =>
      prev.includes(menuName)
        ? prev.filter((m) => m !== menuName)
        : [...prev, menuName],
    );
  };

  const handleInnerToggle = (menuName) => {
    setOpenInnerMenus((prev) =>
      prev.includes(menuName)
        ? prev.filter((m) => m !== menuName)
        : [...prev, menuName],
    );
  };

  const menuItems = [
    {
      title: "My Profile",
      icon: OfficerIcon,
      link: "#",
      submenu: [
        {
          title: "Manage Profile",
          link: "/manage-profile",
        },
      ],
    },
    {
      title: "Tools Purchased",
      icon: tools,
      link: "/tools-purchased",
    },
    {
      title: "Subscriptions",
      icon: subscriptions,
      link: "/subscriptions",
    },
    {
      title: "Insurances",
      icon: insurances,
      link: "/insurances",
    },
    {
      title: "Licenses",
      icon: licenses,
      link: "/licenses",
    },
    {
      title: "Vendors",
      icon: vendor,
      link: "/vendors",
    },
    // {
    //   title: "Industry CRM",
    //   icon: ClientIcon,
    //   link: "/industry-crm",
    //   submenu: [],
    // },
    // {
    //   title: "Contact Form",
    //   icon: ReportIcon,
    //   link: "/contact-form",
    //   submenu: [],
    // },
    // {
    //   title: "Contractors",
    //   icon: LoneIcon,
    //   link: "/contractors",
    //   submenu: [],
    // },
    // {
    //   title: "Job Applications",
    //   icon: OfficerIcon,
    //   link: "/job-applications",
    //   submenu: [],
    // },
  ];

  return (
    <div className={`innerLeft ${isSidebarOpen ? "open" : "closed"}`}>
      <div
        className={`sidebarSec ${
          isSidebarOpen ? "sidebar-visible" : "sidebar-hidden"
        }`}
      >
        <img src={Logo} alt="logo" className="sidebar_logo" />
        <ul className="main_menu">
          {menuItems.map((item, index) => (
            <li
              key={index}
              onClick={() =>
                item?.submenu?.length > 0 && handleToggle(item?.title)
              }
              className={
                openMenus.includes(item?.title) ||
                url?.includes(item?.link) ||
                item?.submenu?.some((sub) => url?.includes(sub?.link)) ||
                item?.submenu?.some((sub) =>
                  sub?.submenu?.some((subInner) =>
                    url?.includes(subInner?.link),
                  ),
                )
                  ? "active"
                  : ""
              }
            >
              <Link to={item?.link} className="outerLink">
                <span className="icon">
                  <img src={item?.icon} alt="sidebarIcon" />
                </span>
                <span className="title">{item?.title}</span>
                {item?.submenu?.length > 0 && (
                  <span className="down_arrow">
                    <i
                      className={`fas ${
                        openMenus.includes(item?.title) ||
                        item?.submenu?.some((sub) =>
                          url?.includes(sub?.link),
                        ) ||
                        item?.submenu?.some((sub) =>
                          sub?.submenu?.some((subInner) =>
                            url?.includes(subInner?.link),
                          ),
                        )
                          ? "fa-chevron-up"
                          : "fa-chevron-down"
                      }`}
                    />
                  </span>
                )}
              </Link>
              {item?.submenu?.length > 0 && (
                <ul
                  className={`submenuSec ${
                    openMenus.includes(item?.title) ||
                    item?.submenu?.some((sub) => url?.includes(sub?.link)) ||
                    item?.submenu?.some((sub) =>
                      sub?.submenu?.some((subInner) =>
                        url?.includes(subInner?.link),
                      ),
                    )
                      ? "open"
                      : ""
                  }`}
                >
                  {item?.submenu?.map((sub, subIndex) => (
                    <li
                      key={subIndex}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (sub?.submenu) handleInnerToggle(sub?.title);
                      }}
                      className={
                        openInnerMenus.includes(sub?.title) ||
                        url?.includes(sub?.link) ||
                        sub?.submenu?.some((subInner) =>
                          url?.includes(subInner?.link),
                        )
                          ? "activeInner"
                          : ""
                      }
                    >
                      <Link to={sub?.link}>
                        {sub?.title}
                        {sub?.submenu && (
                          <span className="down_arrow">
                            <i
                              className={`fas ${
                                openInnerMenus.includes(sub?.title) ||
                                sub?.submenu?.some((subInner) =>
                                  url?.includes(subInner?.link),
                                )
                                  ? "fa-chevron-up"
                                  : "fa-chevron-down"
                              }`}
                            />
                          </span>
                        )}
                      </Link>
                      {sub?.submenu && (
                        <ul
                          className={`innerSubmenuSec ${
                            openInnerMenus.includes(sub?.title) ||
                            sub?.submenu?.some((subInner) =>
                              url?.includes(subInner?.link),
                            )
                              ? "open"
                              : ""
                          }`}
                        >
                          {sub?.submenu?.map((inner, innerIndex) => (
                            <li
                              key={innerIndex}
                              className={`${
                                url?.includes(inner?.link) ? "bottomActive" : ""
                              }`}
                            >
                              <Link to={inner?.link}>{inner?.title}</Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          {/* <li className="last_menu">
            <button className="btn btn-primary">
              Switch to officer Portal
            </button>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
